import { render, staticRenderFns } from "./multimedia-record.vue?vue&type=template&id=6fffa8e1&scoped=true&"
import script from "./multimedia-record.vue?vue&type=script&lang=js&"
export * from "./multimedia-record.vue?vue&type=script&lang=js&"
import style0 from "./multimedia-record.vue?vue&type=style&index=0&id=6fffa8e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fffa8e1",
  null
  
)

export default component.exports